import React, { useState, useEffect, useRef } from "react";
import Navbar from "../Navbar/Navbar";
import DatePicker from "react-datepicker";
import { getCustomerList } from "../../Redux/Gem/Action";
import { Form, Row, Col } from "react-bootstrap";
import "./DailyUpdate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import {
  dailyUpdateAdd,
  dailyUpdateList,
} from "../../Redux/DailyUpdate/Action";
import { useDispatch, useSelector } from "react-redux";
import { format, startOfMonth, endOfMonth } from "date-fns";
import { getProjectMaster, taskNoSearchList } from "../../Redux/Task/Action";
import NewGlobalDataTable from "../DataTable/NewGlobalDataTable";

const DailyUpdate = () => {
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const { dailyUpdateDetails } = useSelector((store) => store.dailyUpdate);
  const { getprojectDropdownData, taskSearchList } = useSelector((store) => store.task);
  const { customerlist } = useSelector((store) => store.gem);
  const [isTaskDropdownOpen, setIsTaskDropdownOpen] = useState(false);
  const taskSelectRef = useRef(null);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    dispatch(getCustomerList(token));
    setdailyUpdateData({
      userId: loginId,
      date: new Date().toISOString().split("T")[0],
      inTime: "",
      outTime: "",
      todaytask: "",
      tomorrowtask: "",
      workdescription: "",
      actionType: "INSERT",
      customerShortName: "",
    });
    setShow(true);
  };
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
  const [toDate, setToDate] = useState(endOfMonth(new Date()));
  const [taskSearch, setTaskSearch] = useState("");

  const [dailyUpdateData, setdailyUpdateData] = useState({
    userId: loginId,
    date: new Date().toISOString().split("T")[0],
    inTime: "",
    outTime: "",
    todaytask: "",
    tomorrowtask: "",
    workdescription: "",
    actionType: "INSERT",
    projectCode: "",
    taskNo: "",
    customerShortName: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.replace(/^\s+/, "");
    setdailyUpdateData((values) => ({
      ...values,
      [name]: trimmedValue,
    }));
  };

  // useEffect(() => {
  //   const formattedFromDate = format(fromDate, "yyyy-MM-dd");
  //   const formattedToDate = format(toDate, "yyyy-MM-dd");
  //   dispatch(
  //     dailyUpdateList(formattedFromDate, formattedToDate, loginId, token)
  //   );
  //   dispatch(getProjectMaster(token));
  // }, [dispatch, fromDate, toDate, loginId, token]);
  const fetchData = (pageNumber, pageSize) => {
    if (loginId) {
      const formattedFromDate = format(fromDate, "yyyy-MM-dd");
      const formattedToDate = format(toDate, "yyyy-MM-dd");
      dispatch(
        dailyUpdateList(
          formattedFromDate,
          formattedToDate,
          loginId,
          token,
          pageSize,
          pageNumber
        )
      );
    }
  };

  useEffect(() => {
    fetchData(pageNumber - 1, pageSize);
    dispatch(getProjectMaster(token));
  }, [dispatch, fromDate, toDate, loginId, pageSize, pageNumber, token]);



  const handleFromDateChange = (e) => {
    setFromDate(new Date(e.target.value));
  };

  const handleToDateChange = (e) => {
    setToDate(new Date(e.target.value));
  };

  useEffect(() => {
    if (dailyUpdateDetails.dailyEmployeeDetails && dailyUpdateDetails.dailyEmployeeDetails.length > 0) {
      setdailyUpdateData((prevData) => ({
        ...prevData,
        ...dailyUpdateDetails.dailyEmployeeDetails[0],
      }));
    }
  }, [dailyUpdateDetails]);


  useEffect(() => {
    if (taskSearch.length >= 3) {
      dispatch(taskNoSearchList(token, taskSearch));
      setIsTaskDropdownOpen(true);
    } else {
      setIsTaskDropdownOpen(false);
    }
  }, [taskSearch, token, dispatch]);
  useEffect(() => {
    if (isTaskDropdownOpen && taskSelectRef.current) {
      taskSelectRef.current.focus();
    }
  }, [isTaskDropdownOpen]);

  const columns = [
    // {
    //   name: "Sn",
    //   selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
    //   sortable: false,
    //   width: "80px",
    // },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "In & Out Time",
      selector: (row) => (
        <div>
          {row.inTime}
          <br />
          {row.outTime}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Project",
      selector: (row) => row.projectCode,
      sortable: true,
    },
    {
      name: "Lab",
      selector: (row) => row?.customerShortName || "",
      sortable: true,
    },
    {
      name: "Today's Task",
      selector: (row) => row.todaytask,
      sortable: true,
    },
    // {
    //   name: "Tomorrow's Task",
    //   selector: (row) => row.tomorrowtask,
    //   sortable: true,
    // },
    // {
    //   name: "Work Description",
    //   selector: (row) => row.workdescription,
    //   sortable: true,
    // },
    {
      name: "Remarks",
      selector: (row) => row.remark,
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => {
        switch (row.status) {
          case "Y":
            return "Approved";
          case "N":
            return "Not Approved";
          case "C":
            return "Commented";
          default:
            return "Unknown Status";
        }
      },
      sortable: false,
    },
    // {
    //   name: "Comments",
    //   selector: (row) => row.comment,
    //   sortable: true,
    // },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    const inTime = new Date(`1970-01-01T${dailyUpdateData.inTime}:00`);
    const outTime = new Date(`1970-01-01T${dailyUpdateData.outTime}:00`);
    const totalHours = (outTime - inTime) / (1000 * 60 * 60);
    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to submit the task details?<br><strong>Total hours worked:</strong> ${totalHours.toFixed(
        2
      )} hours`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(dailyUpdateAdd(dailyUpdateData, token))
          .then(({ success, error }) => {
            if (success) {
              handleClose();
              const formattedFromDate = format(fromDate, "yyyy-MM-dd");
              const formattedToDate = format(toDate, "yyyy-MM-dd");
              dispatch(
                dailyUpdateList(
                  formattedFromDate,
                  formattedToDate,
                  loginId,
                  token,
                  pageSize,
                  pageNumber - 1
                )
              );
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Task details submitted successfully.",
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text:
                  // error ||
                  "Multiple Work hours Can't be Accepted.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error submitting the task details.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: " rgb(46 112 202)",
        color: "white",
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
  };

  return (
    <div>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div>
            <Row className="mb-3 align-items-center">

              {/* ADD TASK BUTTON */}
              <Col
                xs={12}
                sm="auto"
                className="d-flex justify-content-center justify-content-sm-start mb-2 mb-sm-0"
              >
                <button className="btn btn-primary w-100 w-sm-auto" onClick={handleShow}>
                  ADD TASK
                </button>
              </Col>

              {/* RIGHT SIDE GROUP */}
              <Col
                xs={12}
                sm="auto"
                className="d-flex flex-column flex-sm-row align-items-sm-center ms-sm-auto gap-2"
              >

                {/* From Date */}
                <div className="w-100">
                  <b><label className="custom-label">From Date</label></b>
                  <DatePicker
                    selected={fromDate}
                    onChange={(date) => setFromDate(date)}
                    className="form-control date-control"
                    dateFormat="dd-MM-yyyy"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    onKeyDown={(event) => event.preventDefault()}
                  />
                </div>

                {/* To Date */}
                <div className="w-100">
                  <b><label className="custom-label">To Date</label></b>
                  <DatePicker
                    selected={toDate}
                    onChange={(newValue) => setToDate(newValue)}
                    className="form-control date-control"
                    dateFormat="dd-MM-yyyy"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    onKeyDown={(event) => event.preventDefault()}
                    minDate={fromDate}
                  />
                </div>

              </Col>

            </Row>
          </div>





          <NewGlobalDataTable
            columns={columns}
            data={dailyUpdateDetails?.dailyEmployeeDetails}
            tableName={'DAILY UPDATE'}
            setPageSize={setPageSize}
            setPageNumber={setPageNumber}
            totalRecord={dailyUpdateDetails.totalRecord}
          />


        <div className="mt-4">
          <strong className="text-danger">Note: </strong><em>Kindly fill in the daily update before 9 PM.”</em>
        </div>
        </div>
      </div>
      {show && <div
        className="modal fade leave-modal show"
        tabIndex="-1"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">ADD TASK DETAILS</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row mb-1">

                  {/* <div className="col-md-3">
  <div className="form-group">
    <label htmlFor="taskSelect">
      <b>Task</b>
    </label>
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        id="taskSearch"
        placeholder="Search Task..."
        value={taskSearch}
        onChange={(e) => setTaskSearch(e.target.value)}
        autoComplete="off"
        style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
      />
      <select
        className="form-select"
        name="taskId"
        value={dailyUpdateData.taskId || ""}
        onChange={handleChange}
        id="taskId"
        required
        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
      >
        <option value="">Select Task</option>
        {taskSearchList.map((task) => (
          <option key={task.taskNo} value={task.taskNo}>
            {task.taskNo}
          </option>
        ))}
      </select>
    </div>
  </div>
</div> */}


                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="formDate">
                        <b>Date</b>
                      </label>

                      <DatePicker
                        selected={new Date()}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        onKeyDown={(event) => event.preventDefault()}
                        disabled
                      />

                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="formInTime">
                        <b>In Time</b><span className="text-danger">*</span>
                      </label>
                      <input
                        type="time"
                        id="formInTime"
                        className="form-control"
                        name="inTime"
                        value={dailyUpdateData.inTime}
                        onChange={(e) => {
                          handleChange(e);
                          e.target.blur();
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="formOutTime">
                        <b>Out Time</b><span className="text-danger">*</span>
                      </label>
                      <input
                        type="time"
                        id="formOutTime"
                        className="form-control"
                        name="outTime"
                        value={dailyUpdateData.outTime}
                        onChange={(e) => {
                          handleChange(e);
                          e.target.blur();
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="projectCode">
                        <b>Project</b><span className="text-danger">*</span>
                      </label>
                      <select
                        name="projectCode"
                        value={dailyUpdateData.projectCode || ""}
                        onChange={handleChange}
                        id="projectCode"
                        className="form-select"
                        required
                      >
                        <option value="">Choose Option...</option>
                        {getprojectDropdownData.map((projectCode) => (
                          <option
                            key={projectCode.projectMasterId}
                            value={projectCode.projectCode}
                          >
                            {projectCode.projectName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="customerShortName">
                        <b>Lab</b><span className="text-danger">*</span>
                      </label>
                      <select
                        name="customerShortName"
                        value={dailyUpdateData.customerShortName || ""}
                        onChange={handleChange}
                        id="customerShortName"
                        className="form-select"
                        required
                      >
                        <option value="">Choose Option...</option>
                        {customerlist && customerlist?.length > 0 && customerlist.map((lab) => (
                          <option
                            key={lab.customerId}
                            value={lab.customerShortName}
                          >
                            {lab.customerShortName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* <div className="col-md-6">
                    <div className="form-group" style={{ position: "relative" }}>
                      <label htmlFor="taskSearchDropdown">
                        <b>Task</b>
                      </label>
                      <div
                        className="dropdown"
                        style={{ width: "100%" }}
                        tabIndex={0}
                        onBlur={() => setIsTaskDropdownOpen(false)}
                      >
                        <input
                          type="text"
                          className="form-control"
                          id="taskSearchDropdown"
                          placeholder="Search Task..."
                          value={taskSearch}
                          onChange={e => {
                            setTaskSearch(e.target.value);
                            if (e.target.value.length >= 3) setIsTaskDropdownOpen(true);
                            else setIsTaskDropdownOpen(false);
                          }}
                          autoComplete="off"
                          onFocus={() => {
                            if (taskSearch.length >= 3) setIsTaskDropdownOpen(true);
                          }}
                          style={{ paddingLeft: "2rem" }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            left: "10px",
                            top: "38px",
                            color: "#aaa",
                            pointerEvents: "none",
                            zIndex: 2,
                          }}
                        >
                          <i className="bi bi-search"></i>
                        </span>
                        {isTaskDropdownOpen && (
                          <ul
                            className="list-group"
                            style={{
                              position: "absolute",
                              width: "100%",
                              zIndex: 10,
                              maxHeight: "200px",
                              overflowY: "auto",
                              border: "1px solid #ddd",
                              borderTop: "none",
                              background: "#fff",
                            }}
                          >
                            {taskSearchList.length === 0 && (
                              <li className="list-group-item text-muted">No tasks found</li>
                            )}
                            {taskSearchList.map(task => (
                              <li
                                key={task.taskNo}
                                className="list-group-item list-group-item-action"
                                style={{ cursor: "pointer" }}
                                onMouseDown={() => {
                                  setdailyUpdateData(prev => ({
                                    ...prev,
                                    taskNo: task.taskNo,
                                  }));
                                  setTaskSearch(task.taskNo);
                                  setIsTaskDropdownOpen(false);
                                }}
                              >
                                {task.taskNo}
                              </li>
                            ))}
                          </ul>
                        )}
                        {taskSearch.length > 0 && taskSearch.length < 3 && (
                          <small className="text-muted">Type at least 3 characters to search.</small>
                        )}
                      </div>
                      <input
                        type="hidden"
                        name="taskNo"
                        value={dailyUpdateData.taskNo || ""}
                        required
                      />
                    </div>
                  </div> */}
                </div>
                <div className="form-group mb-1">
                  <label htmlFor="todaytask">
                    <b>Task Done Today</b><span className="text-danger">*</span>
                  </label>
                  <textarea
                    type="text"
                    id="todaytask"
                    className="form-control"
                    name="todaytask"
                    rows={3}
                    value={dailyUpdateData.todaytask}
                    onChange={handleChange}
                    required
                  />
                </div>
                {/* <div className="form-group mb-3">
                  <label htmlFor="tomorrowtask">
                    <b>Tomorrow Task</b>
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    name="tomorrowtask"
                    id="tomorrowtask"
                    rows={3}
                    value={dailyUpdateData.tomorrowtask}
                    onChange={handleChange}
                    required
                  />
                </div> */}
                {/* <div className="form-group mb-3">
                  <label htmlFor="workdescription">
                    <b>Work Description</b>
                  </label>
                  <textarea
                    className="form-control"
                    name="workdescription"
                    id="workdescription"
                    rows={5}
                    value={dailyUpdateData.workdescription}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div> */}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary mt-3">
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  );
};

export default DailyUpdate;
